export class Warehouse {
  id: number = -1;

  name: string = '';
  description: string = '';

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
